import * as React from 'react';
import { IScrollToSlideParams, ISlider } from '../types';
import { getSafeSlide } from '../utils';
import * as styles from './MobileSlider.css';
import { IMobileSliderProps, TSwipeSide } from './types';
import { scrollToSlide, addSwipeListener, getContainerStyle, getSlideStyle, checkSlideInsideContainer } from './utils';

export class MobileSlider extends React.Component<IMobileSliderProps, {}> implements ISlider {
  public static defaultProps = {
    initialSlide: 0,
    indents: {},
    onScrollLeft: () => {},
    onScrollRight: () => {},
  };

  private containerRef = React.createRef<HTMLDivElement>();
  private removeSwipeListener = () => {};

  public componentDidMount() {
    const { initialSlide } = this.props;
    const containerNode = this.containerRef.current;

    if (initialSlide !== 0) {
      this.scrollToSlide(initialSlide, { enableAnimation: false });
    }

    if (containerNode) {
      this.removeSwipeListener = addSwipeListener(containerNode, this.handleSwipe);
    }
  }

  public componentWillUnmount() {
    this.removeSwipeListener();
  }

  public scrollToSlide = (candidateSlide: number, params: IScrollToSlideParams = {}) => {
    const { children } = this.props;
    const { enableAnimation = true } = params;
    const containerNode = this.containerRef.current;
    const lastSlide = children.length - 1;

    const slide = getSafeSlide({ slide: candidateSlide, lastSlide });
    const slideNode = this.getSlideNode(slide);

    if (!containerNode || !slideNode) {
      return;
    }

    scrollToSlide({ slideNode, containerNode, enableAnimation });
  }

  private getSlideNode = (currentSlide: number): null | HTMLElement => {
    const containerNode = this.containerRef.current;

    if (!containerNode) {
      return null;
    }

    const slideNode = containerNode.children[currentSlide] as HTMLElement | void;

    return slideNode || null;
  }

  private handleSwipe = (side: TSwipeSide) => {
    const { onScrollRight, onScrollLeft } = this.props;

    if (side === 'right') {
      onScrollRight();
    } else {
      onScrollLeft();
    }
  }

  private handleSlideClick = (event: React.MouseEvent<HTMLElement>) => {
    const containerNode = this.containerRef.current;
    const slideNode = event.currentTarget;

    if (!containerNode) {
      return;
    }

    const isSlideInsideContainer = checkSlideInsideContainer({ containerNode, slideNode });

    if (!isSlideInsideContainer) {
      scrollToSlide({ slideNode, containerNode, enableAnimation: true });
    }
  }

  public render() {
    const { children, slideWidth, indents } = this.props;

    const containerStyle = getContainerStyle({ indents, slideWidth });

    return (
      <div ref={this.containerRef} className={styles['container']} style={containerStyle}>
        {React.Children.map(children, (child, index) => {
          const isLastSlide = index === children.length - 1;
          const slideStyle = getSlideStyle({ indents, isLastSlide });

          return (
            <div className={styles['slide']} style={slideStyle} onClick={this.handleSlideClick}>
              {child}
            </div>
          );
        })}
      </div>
    );
  }
}
